/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-params */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { userLocator } from "../../../utils/auto-complete/user-locator";
import LocationFinderOption from "../../shared/location-finder-option";
import Modal from "../../shared/modal";
import IconGPS from "../../shared/icon-gps/images/gps-white-icon.svg";
import style from "./styles.css";
import LinerLocationpoint from "./images/current-location.svg";
import LineLocationMarker from "./images/PincodeIcon.svg";
import InputGroupAppend from "../../desktop/input-group-append";
import { updateCurrentCityWithPicker } from "../../../utils/helpers/set-current-city";
import EventHandler from "../../../utils/event-handler";
import { emitEventNames } from "../../../constants/event-constants";
import { withRouter } from "react-router-dom";
import { sendCustomGaEvents } from "../../../tracking";
import { homepageCitySelection, pincodeSelected, setupLocationPopup } from "./tracking";
import { sanitizeObject } from "../../../utils/helpers/sanitizers";
import Button from "../../shared/button";
import parseCookie from "../../../utils/helpers/parse-cookie";
import LocationPopup from "../location-popup";
import { LOCATION_TAB, DEFAULT_C2C_CITY, NUMBER } from "../../../constants/app-constants";
import { isValidRouesForPincode } from "../../shared/location-popup/constants";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import { presetCity } from "./constant";
import Filters from "../../../utils/filters-v3";
import { PREVENT_AUTO_SELECT_CITY } from "./constant";
import { getCarListPayload } from "../../../utils/helpers/get-pa-offer-terms";
import { SORT_TYPES_V2 } from "../../../constants/sort-types";
import { CF_STATUS } from "../../../constants/cf-constants";
import { currentLocation, fetchedLocationSucess } from "./tracking";
import CloseButton from "../../shared/icon-cross";
import { statsigInitialization } from "../../../utils/statsig-ab-utils/initialize-user-csr";
import { flushSync } from "react-dom";

const STEP_EVALUATION = ["/one-step-evaluation", "/car-evaluation", "/sell-online"];

const BLOCKED_PICKER_ROUTES = [
    "/appointment/index/",
    "/appointment/index",
    "/appointment/confirmation/",
    "/appointment/confirmation",
    "/buy-used-cars",
    "/buy-used-cars/",
    "/sell-used-cars/",
    "/sell-used-cars",
    "/sell-marketing/",
    "/sell-marketing",
    "/used-car-valuation",
    "/used-car-valuation/",
    "/about-us",
    "/about-us/"
    // "/rto-details",
    // "/rto-details/"
    // "/my-orders",
    // "/my-orders/"
];

const BLOCKED_ROUTE_NAMES = [
    "car-listing",
    "car-detail",
    "sell-used-car",
    "buy-used-cars-home",
    "contact",
    "buy-used-cars",
    "used-car-evaluation",
    "buyers-terms-and-conditions",
    "why-cars24",
    "buyers-privacy-policy",
    "refer",
    "user-consent-terms",
    "customer-review-submission",
    "customer-review",
    "financing",
    "insurance",
    "privacy-policy",
    "hall-of-fame",
    "terms-and-condition",
    "nda",
    "security",
    "tu-cibil-terms",
    "documents",
    "how-it-works",
    "need-help",
    "mobile-apps",
    "terms-and-conditions",
    "contact-us",
    "terms-of-use",
    "sell-used-cars-feedback",
    "cars24-protect",
    "bank-statement-upload",
    "interest-form",
    "used-car-loan",
    "car-loan",
    "loan-status",
    "employee-fnf",
    "scrap-cars",
    "seller-financing",
    "personal-loan",
    "pre-delivery-inspection"
    // "rto-details"
    // "my-orders"
];

const LocationPickerPopup = ({
    history,
    showLocationPicker = false,
    toggleLocationPickerConnect,
    fetchGeoDetailsConnect,
    updateNearestBranchSearchKeyConnect,
    setSelectionTypeConnect,
    selectCityConnect,
    cityList,
    selectedCity,
    route = {},
    error,
    pincode: pincodeConnected,
    resetErrorConnect,
    // isBuyCarPincodeConfigSSR,
    pincodeConfigData,
    setLocationSelectionTypeConnect,
    locationSelectionType,
    cityID: trackCityId,
    setComingSoonConnect,
    ciAvailable,
    isPincodeSSR,
    updatePincodeSSRStatusConnect,
    location: historyLocation,
    pageType,
    isCityUnavailable,
    setCityAvailabilityConnect,
    setIsIndiaPageConnect,
    isIndiaPage,
    gaId,
    reloadCarListConnect,
    appliedOptions,
    resetFiltersConnect,
    fetchFiltersConnect,
    setShowPopularCitiesOnHomepageConnect,
    getServiceabilityCheckConnect,
    creditStatus,
    selectedOffer,
    preApproved,
    preApprovalScreenVariant,
    fetchNearByCarsListConnect,
    userId,
    isServiceable,
    isSSrServiceable,
    isNearByCityAvailable,
    carListError,
    updateSSRStatusConnect,
    updateUserLocationConnect,
    showManualPincodePopup,
    setShowManualPincodePopupConnect,
    updateStatsigConfigConnect,
    updateStatsigTimeStampConnect
}) => {
    const [pincode, setPincode] = useState(pincodeConnected || "");
    const [geoError, setGeoError] = useState("");
    const [pincodeError, setPincodeError] = useState("");
    const [isLoadingLocation, setIsLodingLocation] = useState(false);
    const [isManualPincode, setIsManualPincode] = useState(showManualPincodePopup);
    const [locationCityId, setLocationCityId] = useState(trackCityId);
    const [openSubcitiesScreen, setOpenSubcitiesScreen] = useState(false);

    const { pincode: ssrPincode, legacyId: ssrCityId  } = pincodeConfigData || {};

    const queryParams = parseLocationSearchParams(historyLocation.search);
    const scrollToTop = () => {
        if (window && window.document) {
            const body = document.getElementsByTagName("body")[0];
            if (body) {
                body.scrollIntoView();
            }
        }
    };

    useEffect(() => {
        if (showManualPincodePopup) {
            setIsManualPincode(true);
        }
    }, [showManualPincodePopup]);

    const isValidRegex = (v) => /^[1-9]{1}[0-9]{2}[0-9]{3}$/.test(v);
    const pincodeValidator = (v) => {
        return isValidRegex(v);
    };

    const resetCitySelection = () => {
        selectCityConnect(null, null, null, null, null);
        setIsIndiaPageConnect(true);
        // clearItem(CITY_KEY);
    };

    const checkIsComingSoon = (currentPincode, skipComingSoon, cityName, cityId) => {
        if (route && route.isUsedCarRoute && currentPincode) {
            if (isSSrServiceable) {
                if (isServiceable || (!isServiceable && isNearByCityAvailable)) {
                    setComingSoonConnect(false);
                } else {
                    setComingSoonConnect(true);
                }
                updateSSRStatusConnect(false);
            } else if (!carListError && !!cityId) {
                getServiceabilityCheckConnect(cityId).then((serviceabilityData) => {
                    if (serviceabilityData && !serviceabilityData.serviceable) {
                        const payload = getCarListPayload(preApprovalScreenVariant, selectedOffer);
                        const data = {
                            searchFilter: [],
                            cityId,
                            pincode: currentPincode,
                            sort: SORT_TYPES_V2.bestMatch.items.default.payload,
                            size: NUMBER.EIGHT,
                            ...(preApproved && creditStatus !== CF_STATUS.DISCARDED && { financeInfo: payload })
                        };
                        fetchNearByCarsListConnect({data}).then((nearbyData) => {
                            if (nearbyData && nearbyData.nearbyCities && nearbyData.nearbyCities.length) {
                                setComingSoonConnect(false);
                            } else {
                                setComingSoonConnect(true);
                            }
                        });
                    } else {
                        setComingSoonConnect(false);
                    }
                });
            }
        }
    };

    const redirectToListing = ({ cityId, currentPincode, seoLink }) => {
        fetchFiltersConnect({ data: { cityId: cityId || "" }, clientId: gaId }).then(() => {
            const appliedFilter = new Filters({ cityID: cityId, currentPincode });
            const listingUrl = seoLink || appliedFilter.getListingUrl({
                options: {
                    ...appliedOptions
                }
            }).relativeURL;
            flushSync(() => route.name === "buy-used-cars-home" ? history.push(listingUrl) : history.replace(listingUrl));
            flushSync(() => reloadCarListConnect(true));
        });
    };

    const onCitySelect = (cityInfo, currentPincode, skipComingSoon) => {
        const {
            city_id: cityId,
            city_name: cityName,
            background_image_mobile: backgroundImage,
            buy_used_car_url: buyUsedCarUrl,
            buy_used_car_url_sec_cta: viewAllCarsUrl
        } = cityInfo;

        setCityAvailabilityConnect(true);

        // const parsedCityList = getFilteredCities();
        if (backgroundImage) {
            updateCurrentCityWithPicker(cityInfo, selectCityConnect, false, currentPincode);
            sendCustomGaEvents({
                ...homepageCitySelection,
                city: cityName
            });
            updateNearestBranchSearchKeyConnect(); //remounts the nearest branch search bar component
            setSelectionTypeConnect("city");

            EventHandler.getInstance().emitEvent(
                emitEventNames.mobile.ON_CITY_SELECTION,
                {
                    id: cityId,
                    name: cityName,
                    image: backgroundImage,
                    url: buyUsedCarUrl,
                    viewAllCarsUrl
                }
            );
            setIsIndiaPageConnect(false);
        } else {
            resetCitySelection();
            // skipCitySelectionConnect(true);
        }
        toggleLocationPickerConnect(false);
        checkIsComingSoon(currentPincode, skipComingSoon, cityName, cityId);

        /* to avoid Filter API (in configuration file) on initial render isPincodeSSR is set to true,
        soon after user change city updatePincodeSSRStatusConnect is set to false so Filter API can be called again
        setTimeout => to make some delay so that Filter API can be bypassed on first render */

        window.setTimeout(() => {
            if (isPincodeSSR) updatePincodeSSRStatusConnect(false);
        }, NUMBER.THOUSAND);
    };

    const handlePincodeChange = ({ cookieCityId, data = {}, skipComingSoon = false, isManuallySelectedCity }) => {
        const selectedCityId = data ? data.city_id : (cookieCityId || locationCityId);
        // setGeoError("");
        // if (pincodeValidator(selectedPincode)) {
        setPincodeError("");
        updateUserLocationConnect({ cityId: (selectedCityId || "").toString() }).then(async (cityInfo) => {
            const { pincode: currentPincode, city_id: currentCityId, is_seo_city: isSeoCity, city_slug: citySlug, seo_link: seoLink } = cityInfo;
            if ((route.name === "car-listing" ||  route.name === "buy-used-cars-home") && isManuallySelectedCity) {
                resetFiltersConnect();
            }
            onCitySelect(sanitizeObject(cityInfo), currentPincode, skipComingSoon);
            if (isManuallySelectedCity) {
                updateStatsigConfigConnect({statsigInitialized: true});
                await statsigInitialization({city: currentCityId, clientId: gaId, updateUser: true});
                updateStatsigTimeStampConnect();
                sendCustomGaEvents({
                    ...pincodeSelected,
                    eventCategory: pageType,
                    eventLabel: cityInfo.is_featured ? "popular_cities" : "other_cities",
                    dimension88: currentPincode,
                    dimension21: cityInfo.city_id
                });
                if (route.name === "car-listing" || (route.name === "buy-used-cars-home" && !(isSeoCity && citySlug))) {
                    redirectToListing({ cityId: currentCityId, currentPincode, seoLink: seoLink ? `/${seoLink}` : "" });
                }
            }
            scrollToTop();
        });

    };

    useEffect(() => {
        if (isCityUnavailable) {
            toggleLocationPickerConnect(false);
        } else if (BLOCKED_PICKER_ROUTES.includes(history.location.pathname)) {
            if (locationSelectionType === LOCATION_TAB.MANUAL) {
                toggleLocationPickerConnect(true);
            } else {
                toggleLocationPickerConnect(false);
            }

        } else if (!queryParams.disableLocationPicker && !pincodeConnected && !BLOCKED_ROUTE_NAMES.includes(route.name)) {
            toggleLocationPickerConnect(true);
        } else {
            toggleLocationPickerConnect(false);
        }
    }, []);

    useEffect(() => {
        if (route.name) {
            if (!isValidRouesForPincode(route.name)) {
                if (!pincodeConnected) {
                    setIsManualPincode(false);
                } else if (showLocationPicker && !isCityUnavailable) setIsManualPincode(true);
            } else {
                setIsManualPincode(false);
            }
        }
    }, [showLocationPicker, route]);

    useEffect(() => {
        setPincode(pincodeConnected);
    }, [pincodeConnected]);

    const getCustomDimension = () => {
        return {
            dimension140: selectedCity.id,
            dimension148: userId
        };
    };

    const [pushLocationChangeEvent, setPushLocationChangeEvent] = useState(false);
    const onDetectLocation = (e) => {
        e.preventDefault();
        sendCustomGaEvents({
            ...currentLocation,
            ...getCustomDimension(),
            eventLabel: "text_prompt",
            dimension144: selectedCity.name
        });
        setShowManualPincodePopupConnect(false);
        setLocationSelectionTypeConnect(LOCATION_TAB.CURRENT);
        setIsLodingLocation(true);
        setPincodeError("");
        setGeoError("");
        userLocator(async (location) => {
            setIsLodingLocation(false);
            fetchGeoDetailsConnect(location).then((response) => {
                const { city_info: cityInfo, pincode: currentPincode, city_id: currentCityId } = response;
                if (route.name === "car-listing" || route.name === "buy-used-cars-home") {
                    resetFiltersConnect();
                }
                onCitySelect(sanitizeObject(cityInfo), currentPincode);
                setPushLocationChangeEvent(true);
                setIsIndiaPageConnect(false);
                setShowPopularCitiesOnHomepageConnect(false);
                sendCustomGaEvents({
                    ...fetchedLocationSucess,
                    eventLabel: cityInfo.city_name,
                    ...getCustomDimension(),
                    dimension144: cityInfo.city_name
                });
                scrollToTop();
                if (route.name === "car-listing" ||  route.name === "buy-used-cars-home") {
                    redirectToListing({ cityId: currentCityId, currentPincode });
                }
            });
        }, () => {
            setIsLodingLocation(false);
            setGeoError("Could not access location, please enable access through device settings");
        });
    };

    useEffect(() => {
        if (pushLocationChangeEvent) {
            if (!isManualPincode) {
                sendCustomGaEvents({
                    ...setupLocationPopup,
                    eventCategory: pageType,
                    eventLabel: "use_current_location",
                    dimension88: pincode,
                    dimension21: trackCityId
                });
            } else {
                sendCustomGaEvents({
                    ...pincodeSelected,
                    eventCategory: pageType,
                    eventLabel: "current_location",
                    dimension88: pincode,
                    dimension21: trackCityId
                });
            }
            setPushLocationChangeEvent(false);
        }
    }, [pincode, pushLocationChangeEvent]);

    const onPincodeLocation = (data) => {
        setShowManualPincodePopupConnect(false);
        handlePincodeChange({ cookieCityId: null, data, isManuallySelectedCity: true });
    };

    const onPincodeLocationEnter = () => {
        handlePincodeChange({ cookieCityId: null, data: null });
    };

    const onFocusCallback = () => {
        resetErrorConnect();
        setPincodeError("");
    };

    const getFilteredCities = () => {
        let cities = cityList;
        if (route && route.isUsedCarRoute) {
            cities = cityList.filter((item) => item.is_buy_used_car);
        } else {
            cities = cityList.filter((item) => !item.is_virtual_city);
        }
        return cities;
    };

    /*
        holds all the logic of specific to branch module
    */

    const onClose = () => {
        // setGeoError("");
        if (!isServiceable && !isNearByCityAvailable) {
            return;
        } else {
            setPincodeError("");
            resetErrorConnect();
            toggleLocationPickerConnect();
            setShowPopularCitiesOnHomepageConnect(true);
            // Use this to force user to select location/pincode on load
            // if (pincodeConnected) {
            //     toggleLocationPickerConnect();
            // }
            if ((!pincodeConnected && !PREVENT_AUTO_SELECT_CITY.includes(history.location.pathname)) || queryParams.disableLocationPicker) {
                handlePincodeChange({
                    cookieCityId: null,
                    data: { city_id: DEFAULT_C2C_CITY.city_id }
                });
            }
        }
    };

    const goBack = () => {
        if (!pincodeConnected) {
            setIsManualPincode(!isManualPincode);
        } else {
            toggleLocationPickerConnect();
            if (!ciAvailable) {
                checkIsComingSoon(pincode, false, ((selectedCity && selectedCity.name) ? selectedCity.name : ""), selectedCity?.id);
            }
        }
    };

    useEffect(() => {
        const skipPincodeChange = (BLOCKED_PICKER_ROUTES.includes(history.location.pathname) || isCityUnavailable) && !presetCity.includes(history.location.pathname);
        if (skipPincodeChange) return;
        const cookiePincode = parseCookie("pincode");
        const cookieCityId = parseCookie("user_selected_city");
        let appliedPincode = "";
        let appliedCityId = "";

        if (isPincodeSSR && ssrPincode) {
            appliedPincode = ssrPincode;
        } else if (cookiePincode) {
            appliedPincode = cookiePincode;
        }
        if (isPincodeSSR && ssrCityId) {
            appliedCityId = ssrCityId;
        } else if (cookieCityId) {
            appliedCityId = cookieCityId;
        }
        setPincode(appliedPincode);
        setLocationCityId(appliedCityId);
        if (STEP_EVALUATION.includes(history.location.pathname) || (history.location.pathname || "").match(/^\/centres\/[a-z\-]+/i)) return;
        if (!isIndiaPage) {
            handlePincodeChange({
                cookieCityId: appliedCityId,
                data: null,
                skipComingSoon: true
            });
        }

    }, [isIndiaPage]);

    const handleManualPincodeSelection = () => {
        setLocationSelectionTypeConnect(LOCATION_TAB.MANUAL);
        setIsManualPincode(true);
        sendCustomGaEvents({
            ...setupLocationPopup,
            eventCategory: pageType,
            eventLabel: "select_manually"
        });
    };

    const closeModal = () => {
        if (openSubcitiesScreen) {
            setOpenSubcitiesScreen(false);
        }
        onClose();
    };

    return (
        <React.Fragment>

            <Modal isOpen={showLocationPicker} close={closeModal}>
                <div styleName={`style.popupWrapper ${isManualPincode ? "style.modalHeight" : ""}`}>
                    <div styleName={"style.popupHeader"}>
                        <h4>Select your city</h4>
                        {
                            isManualPincode &&
                            <span styleName={"style.close"} onClick={closeModal}>
                                <CloseButton type={"black"} />
                            </span>
                        }

                    </div>
                    <div className="container">
                        {!isManualPincode && <div styleName={"style.locationWrapper"}>
                            <div styleName="style.rowWrapper">
                                <LocationFinderOption
                                    imageURL={LinerLocationpoint}
                                    heading="Use my current location"
                                    detailsText="We’ll need permission to use your device’s location"
                                />
                                <div styleName="style.locationButton">
                                    <Button
                                        onClick={onDetectLocation}
                                        text="USE CURRENT LOCATION"
                                        isLoading={isLoadingLocation}
                                        leftImage={isLoadingLocation ? null : IconGPS}
                                        disabled={!!geoError}
                                    />
                                </div>
                                {geoError && <span styleName="style.locationError">We are unable to access your location.<br />Kindly provide location permission to Cars24 from your browser settings.</span>}
                            </div>
                            <p styleName="style.orOption">
                                <span>OR</span>
                            </p>
                            <div styleName="style.rowWrapper">
                                <LocationFinderOption
                                    imageURL={LineLocationMarker}
                                    heading="Select Manually"
                                    detailsText="Search by your City" />
                                <div styleName="style.inputWrapper">
                                    {isValidRouesForPincode(route.name) ? <InputGroupAppend
                                        value={pincode}
                                        onChange={(e) => setPincode(e.target.value)}
                                        validator={pincodeValidator}
                                        onSubmitHandler={onPincodeLocationEnter}
                                        isError={!!error || !!pincodeError}
                                        serverErrorMessage={error && error.message || pincodeError}
                                        onFocusCallback={onFocusCallback}
                                    /> :
                                        <Button onClick={handleManualPincodeSelection} text="SELECT MANUALLY" />}
                                </div>
                            </div>
                        </div>}
                    </div>
                    {isManualPincode && <div>
                        <LocationPopup
                            goBack={goBack}
                            onPincodeLocation={onPincodeLocation}
                            parsedCityList={getFilteredCities()}
                            route={route}
                            onClickHandler={onDetectLocation}
                            geoError={geoError}
                            openSubcitiesScreen={openSubcitiesScreen}
                            setOpenSubcitiesScreen={setOpenSubcitiesScreen}
                        />
                    </div>}
                </div>
            </Modal>

        </React.Fragment>

    );
};

LocationPickerPopup.propTypes = {
    showLocationPicker: PropTypes.bool,
    toggleLocationPickerConnect: PropTypes.func.isRequired,
    fetchGeoDetailsConnect: PropTypes.func.isRequired,
    setPositionConnect: PropTypes.func.isRequired,
    updateNearestBranchSearchKeyConnect: PropTypes.func,
    setSelectionTypeConnect: PropTypes.func,
    selectCityConnect: PropTypes.func,
    cityList: PropTypes.any,
    route: PropTypes.object,
    history: PropTypes.any,
    pincode: PropTypes.number,
    resetErrorConnect: PropTypes.func,
    error: PropTypes.any,
    // isBuyCarPincodeConfigSSR: PropTypes.bool,
    pincodeConfigData: PropTypes.object,
    setLocationSelectionTypeConnect: PropTypes.func,
    locationSelectionType: PropTypes.string,
    selectedCity: PropTypes.object,
    cityID: PropTypes.string,
    setComingSoonConnect: PropTypes.func,
    ciAvailable: PropTypes.bool,
    isPincodeSSR: PropTypes.bool,
    updatePincodeSSRStatusConnect: PropTypes.func,
    location: PropTypes.object,
    pageType: PropTypes.string,
    isCityUnavailable: PropTypes.bool,
    setCityAvailabilityConnect: PropTypes.func,
    setIsIndiaPageConnect: PropTypes.func,
    isIndiaPage: PropTypes.bool,
    reloadCarListConnect: PropTypes.func,
    appliedOptions: PropTypes.object,
    appliedFilters: PropTypes.array,
    resetFiltersConnect: PropTypes.func,
    fetchFiltersConnect: PropTypes.func,
    setShowPopularCitiesOnHomepageConnect: PropTypes.func,
    gaId: PropTypes.string,
    getServiceabilityCheckConnect: PropTypes.func,
    isServiceable: PropTypes.bool,
    fetchNearByCarsListConnect: PropTypes.func,
    preApproved: PropTypes.bool,
    preApprovalScreenVariant: PropTypes.string,
    creditStatus: PropTypes.string,
    selectedOffer: PropTypes.object,
    userId: PropTypes.string,
    isSSrServiceable: PropTypes.bool,
    isNearByCityAvailable: PropTypes.bool,
    setIsServiceableLoadingConnect: PropTypes.func,
    carListError: PropTypes.any,
    updateSSRStatusConnect: PropTypes.func,
    updateUserLocationConnect: PropTypes.func,
    setShowManualPincodePopupConnect: PropTypes.func,
    showManualPincodePopup: PropTypes.bool,
    updateStatsigConfigConnect: PropTypes.func,
    updateStatsigTimeStampConnect: PropTypes.func,
    updateSortOrderConnect: PropTypes.func
};

export default withRouter(LocationPickerPopup);
